<template>
  <main class="main">
    <div class="mainContainer d-flex flex-wrap">
      <div class="main-left">
        <!-- 表單 -->
        <div class="form-title">
          <p class="text">{{$t('order.information')}}</p>
          <div class="title-underline"></div>
        </div>
        <a-form
          class="main-form"
          :form="form"
          @submit="handleSubmit"
          :label-col="{ span:5 }"
          :wrapper-col="{ span:18 }"
        >
          <a-form-item :label="$t('order.name')">
            <a-input v-decorator="['name', { rules: [{ required: true, message: '請輸入姓名！' }] }]" />
          </a-form-item>
          <a-form-item :label="$t('order.phone')">
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [
                    {
                      required: true,
                      message: '請輸入聯絡電話！',
                    },
                    {
                      validator:validateToPhone
                    }
                  ]
                }
              ]"/>
          </a-form-item>
          <a-form-item v-if="isShoppingRequest && isDeliver" :label="$t('order.phone2')">
            <a-input
              v-decorator="[
                'phone2',
                {
                  rules: [
                    {
                      validator:validateToPhone
                    }]
                }
              ]"/>
          </a-form-item>
          <a-form-item :label="$t('order.emailAddress')">
            <a-input
              :disabled="!!userInfo.email"
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      required: true,
                      message: '請輸入電郵！',
                    },
                    {
                      type: 'email',
                      message: '請輸入有效的電郵！',
                    }
                  ],
                  initialValue: userInfo.email
                },
              ]"
            />
          </a-form-item>
          <a-form-item v-if="isShoppingRequest && isDeliver" :label="$t('order.address')" required>
            <a-input v-decorator="['shippingAddr1', { rules: [{ validator:validateToAddress}], trigger: ['blur', 'change'] }]" />
          </a-form-item>
          <a-form-item v-if="isShoppingRequest && isDeliver" :wrapper-col="{ offset:5, span: 18 }">
            <a-input v-decorator="['shippingAddr2', { rules: [{ validator:validateToAddress}], trigger: ['blur', 'change'] }]" />
          </a-form-item>
          <a-form-item v-if="isShoppingRequest && !isDeliver" :label="$t('order.storeLocation')">
            <a-select
              v-decorator="[
                'storeLocation',
                { rules: [{ required: true, message: '請選擇自取門市！' }] }
              ]"
              option-label-prop="label">
              <a-select-option
                v-for="(item,index) in allAddress"
                :key="index"
                :value="item.value"
                :label="item.name"
                class="addressOptions"
              >
                <p class="mb-0">{{ item.name }}</p>
                <p class="mb-0">{{ item.address }}</p>
                <p class="mb-0">{{ item.phone }}</p>
                <p class="mb-0">{{ item.time }}</p>
              </a-select-option>
            </a-select>
          </a-form-item>
          <!-- <a-form-item
            :label-col="{ span: 0 }"
            :wrapper-col="{ span: 24, offset: 0 }"
          >
            <a-checkbox v-decorator="['agreement', { valuePropName: 'checked' }]">
              {{$t('order.addressFlag')}}
            </a-checkbox>
          </a-form-item> -->
          <a-form-item
            :label-col="{ span: 0 }"
            :wrapper-col="{ span: 24, offset: 0 }"
          >
            <a-button
              class="formSubmitBtn"
              type="primary"
              html-type="submit"
            >
              <i class="iconfont icon-shopping"></i>
              {{$t('order.pay')}}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="main-right">
        <div class="cart-content">
          <h3 class="cbs-title"><i class="iconfont icon-shopping"></i>{{$t('cart.title')}}</h3>
          <ul class="list">
            <li
              class="list-item"
              v-for="(item,index) in orderList"
              :key="item.couponId + index"
            >
              <div class="item-box">
                <div class="item-img">
                  <img
                    :src="item.detailBannerUrl || item.couponPromotionBannerUrl"
                    alt=""
                  >
                </div>
                <div class="item-body">
                  <div class="item-info">
                    <span class="item-title">{{ item.shortDescription }}</span>
                    <span class="item-time">
                      Validity Period：{{item.effectiveStartDate | ValidityDateFormat}} - {{item.effectiveEndDate | ValidityDateFormat}}
                    </span>
                  </div>
                  <div class="item-price-container">
                    <div class="item-quantity">
                      <a-icon type="close" />
                      {{ item.quantity }}
                    </div>
                    <div class="item-price">${{item.price}}</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <!-- <div class="cart-discount">
            <div class="discount-left">
              <span>{{$t('cart.discountText')}}</span>
              <button>{{$t('cart.determine')}}</button>
            </div>
            <div class="discount-right">
              <span>{{$t('cart.discount')}}:</span>
              <span class="price">-$0</span>
            </div>
          </div> -->
          <p class="cart-totalPrice">
            <span>{{$t('cart.totalPrice')}}:</span>
            <span class="price">${{ getOrderTotal }}</span>
          </p>
        </div>
      </div>
    </div>
    <payForm
      :payment="payment"
      v-if="isPay"
    />
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { createOrder, payOrder } from '@/api/coupon'
import payForm from './payForm'
export default {
  data () {
    return {
      form: this.$form.createForm(this, { name: 'order' }),
      payment: {},
      isPay: false,
      email: '',
      allAddress: [
        {
          value: 'timesqure',
          name: '銅鑼灣時代廣場 專門店',
          address: '銅鑼灣時代廣場8樓811-812店',
          phone: '(852) 2506-1488',
          time: '11:00 - 22:00'
        },
        {
          value: 'telford',
          name: '九龍灣德福廣場 專門店',
          address: '九龍灣德福廣場1期G39店',
          phone: '(852) 2920-2148 ',
          time: '11:00 - 22:00'
        },
        {
          value: 'festivalwalk',
          name: '九龍塘又一城 專門店',
          address: '九龍塘達之路80號又一城G-30店',
          phone: '(852) 2436-0478',
          time: '11:00 - 21:00'
        },
        {
          value: 'tmtp',
          name: '屯門市廣場 專門店',
          address: '屯門屯順街1號屯門市廣場1期2068店',
          phone: '(852) 2117-0975 ',
          time: '11:00 - 22:00'
        }
      ]
    };
  },
  components: {
    payForm,
  },
  computed: {
    ...mapState('order', [
      'orderList'
    ]),
    ...mapGetters('order', [
      'getOrderTotal'
    ]),
    ...mapState('user', [
      'userInfo'
    ]),
    isShoppingRequest () {
      return this.orderList[0].shippingRequired
    },
    isDeliver () {
      return this.getOrderTotal >= 3000
    }
  },
  mounted () {
    /* if (!localStorage.getItem('token')) {
      this.$bus.$emit('showLogin', false)
    } */
  },
  filters: {
    ValidityDateFormat (data) {
      return data.split('-').reverse().join('/')
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          console.log(this.orderList)
          // 创建订单请求
          const request = {
            ...values,
            items: this.orderList.map(item => {
              return {
                couponId: item.couponId,
                quantity: item.quantity,
              }
            })
          }
          console.log('request:', request)
          const { data: res } = await createOrder(request).catch(err => {
            this.$message.error(this.$t('error.quantityError'));
          })
          console.log('response:', res)
          if (res && res.items) {
            // 获取付款参数
            const { data: payRes } = await payOrder(res.items[0].orderId, window.location.origin + '/order/' + res.items[0].orderId)
            console.log('获取付款参数response:', payRes)
            this.payment = payRes
            this.isPay = true
          }
        }
      });
    },
    handleSelectChange (value) {
      console.log(value);
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
      });
    },
    // 手机校验规则
    validateToPhone (rule, value, callback) {
      if (!value) return callback()
      const phoneReg = /\d{8}$/
      if (!phoneReg.test(value)) {
        if (rule.field === 'phone') {
          callback(new Error('請輸入有效的聯絡電話！'))
        } else {
          callback(new Error('請輸入有效的聯絡電話2！'))
        }
        return;
      }
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
    // 手机校验规则
    validateToAddress (rule, value, callback) {
      const values = this.form.getFieldsValue(['shippingAddr1', 'shippingAddr2'])
      console.log('values:', values)
      if (Object.values(values).some(item => item)) {
        callback()
      } else {
        callback(new Error('請輸入送貨地址！'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$btn-color: #d4517e;
$btn-hover-color: #c82333;
.main {
  height: 950px;
  background-color: #fff;
  position: relative;
  @media screen and (min-width: 1280px) {
    &::before {
      content: "";
      position: absolute;
      width: calc((100vw - 1280px) / 2);
      height: 100%;
      top: 0;
      left: 0;
      background-color: #fafafa;
    }
  }
  .mainContainer {
    height: 100%;
  }
  .main-left {
    padding: 80px;
    width: 55%;
    height: 100%;
    background-color: #fafafa;

    .form-title {
      text-align: start;
      position: relative;
      font-size: 18px;
      color: #d4517e;
      margin-bottom: 30px;
      &::before {
        position: absolute;
        left: -52px;
        top: 0px;
        content: "1";
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        color: white;
        border-radius: 50%;
        background-color: #d4517e;
      }
      .text {
        margin-bottom: 5px;
      }
      .title-underline {
        position: relative;
        width: 32px;
        height: 5px;
        background-color: #ffbf00;
        border-radius: 3px;
        &::after {
          position: absolute;
          content: "";
          left: 37px;
          width: 5px;
          height: 5px;
          background-color: #ffbf00;
          border-radius: 50%;
        }
      }
    }
    .main-form {
      .ant-form-item {
        text-align: left;
        margin-bottom: 22px;
        &:nth-last-child(n + 2) {
          border-bottom: 1px solid #000;
        }

        ::v-deep .ant-form-item-label {
          text-align: left;
          padding: 0;
          > label {
            font-size: 16px;
            margin: 0;
          }
        }

        ::v-deep .ant-form-explain {
          position: absolute;
          bottom: -22px;
        }
        &:nth-child(2) ::v-deep .ant-form-explain {
          left: 0;
        }

        .ant-input {
          padding-left:0;
          padding-right:0;
          width: 100%;
          font-size: 16px;
          border: none;
          outline: none;
          background-color: transparent;
          // 使用阴影覆盖原有的深蓝色样式
          box-shadow: inset 0 0 0 1000px #fafafa !important;
          color:#000;
          &:focus {
            border-color: none;
            border-right-width: none;
            outline: 0;
            box-shadow: none;
          }
          &[disabled]{
            color:rgba(0, 0, 0, 0.4);
          }
        }
      }
    }

    .formSubmitBtn {
      padding: 15px 0;
      width: 100%;
      height: 100%;
      font-size: 18px;
      border: none;
      outline: none;
      background-color: #d4517e;
      > i {
        font-size: 24px;
        margin-right: 10px;
      }
      &:hover {
        background-color: #c82333;
      }
    }
  }
  .main-right {
    width: 45%;
    height: 100%;
    padding: 40px 50px;
    /* .cart-content {
      position: absolute;
      right: 0;
      width: 45%;
      padding: 24px;
      height: 100%;
      background-color: #fff;
      z-index: 100;
      overflow: auto;
      @media screen and (max-width: 768px) {
        width: 83%;
      }
    } */
  }

  .cbs-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    > i {
      margin-right: 5px;
      font-size: 24px;
    }
  }

  .list {
    padding: 0;
    margin: 0;
    .list-item {
      position: relative;
      padding: 10px 0;
      list-style: none;
      border-top: 1px solid #e5e5e5;
      .item-box {
        display: flex;
      }
      .item-img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        margin-right: 25px;
        @media (max-width: 992px) {
          margin-right: 10px;
        }
        @media (max-width: 768px) {
          margin-right: 5px;
        }
        > img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .item-body {
        display: flex;
        justify-content: space-between;
        flex: 1;
        .item-info {
          display: flex;
          flex-direction: column;
          text-align: left;
          .item-title {
            font-size: 18px;
            color: #000;
          }
          .item-time {
            margin-top: 5px;
            font-size: 14px;
            color: #b3b3b3;
          }
        }
        .item-price-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 0 0 80px;
          .item-quantity {
            display: flex;
            align-items: center;
            padding: 1px 3px;
            border-radius: 4px;
            border: 1px solid #949494;
            > i {
              font-size: 12px;
            }
          }
          .item-price {
            margin-left: 3px;
          }
        }
      }
      .item-pc-remove,
      .list-mp-remove {
        position: absolute;
        top: 0;
        right: 0;
        border: none;
        outline: none;
        overflow: hidden;
      }
      .item-pc-remove {
        background: #fff;
        cursor: pointer;
        transition: all 0.2s ease;
        &:hover {
          background-color: #ddd;
        }
        &:active {
          opacity: 0.8;
        }
        @media screen and (max-width: 768px) {
          display: none;
        }
      }
      .list-mp-remove {
        top: 10px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 84px;
        width: 0;
        height: calc(100% - 24px);
        white-space: nowrap;
        color: white;
        border-radius: 5px;
        background-color: red;
        z-index: 1;
        @media screen and (min-width: 768px) {
          width: 0 !important;
        }
      }
    }
  }

  .cart-discount {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 10px;
    border-top: 1px solid #e8e8e8;
    .discount-left {
      margin-bottom: 10px;
      background-color: #f1f1f1;
      padding: 10px 5px 10px 15px;
      > button {
        margin-left: 10px;
        padding: 0 15px;
        color: white;
        border: none;
        outline: none;
        border-radius: 15px;
        background-color: $btn-color;
        transition: all 0.3s ease;
        &:hover {
          background-color: $btn-hover-color;
        }
      }
    }
    .discount-right {
      margin-bottom: 10px;
      font-size: 16px;
      flex: 1;
      text-align: right;
      white-space: nowrap;
      .price {
        margin-left: 40px;
      }
    }
  }
  .cart-totalPrice {
    padding-top: 15px;
    text-align: right;
    border-top: 1px solid #e8e8e8;
    font-size: 16px;
    .price {
      margin-left: 40px;
    }
  }
  .purchaseBtn {
    width: 100%;
    font-size: 18px;
    color: white;
    outline: none;
    border: none;
    background-color: $btn-color;
    height: 56px;
    border: 5px;
    transition: all 0.5s ease;
    &:hover {
      background-color: $btn-hover-color;
    }
    > i {
      font-size: 24px;
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 997px) {
    height: auto;
    .mainContainer {
      flex-direction: column-reverse;
      .main-left,
      .main-right {
        padding: 20px;
        width: 100%;
      }
      .main-left {
        .ant-form-item {
          display: flex;
          ::v-deep .ant-form-item-label {
            display: flex;
            width: auto;
            align-items: center;
            @media (max-width: 575px) {
              margin-right: 8px;
            }
          }

          ::v-deep .ant-form-item-control-wrapper {
            flex: 1;
          }
        }
        .formSubmitBtn {
          padding: 5px 0;
        }
        .addressOptions ~ .addressOptions {
          border-bottom: 1px solid #eee;
        }
      }
    }
  }
}
</style>
<style>
.addressOptions {
  white-space: normal;
}
.addressOptions ~ .addressOptions {
  border-top: 1px solid #eee;
}
</style>
